import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { FinancialDocumentListItem } from "@common/types/financialDocument";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { DocumentName } from "../../DocumentName";

export const NameCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, FinancialDocumentListItem, string>) => {
        const document = row.original;

        return (
            <ViewTableCell>
                <DocumentName
                    fileName={document.fileName}
                    documentId={document.id}
                />
            </ViewTableCell>
        );
    },
);
